<div *ngIf="isPageInitialized" class="h-full w-full">
  <mat-tab-group
    [(selectedIndex)]="selectedIndex"
    (selectedTabChange)="tabChanged($event)"
    class="h-full w-full"
  >
    <!-- Tab 0: Project Details / Theme Allocation -->
    <mat-tab [label]="tab0Label" class="h-full w-full">
      <app-project-info-tab></app-project-info-tab>
    </mat-tab>

    <!-- Tab 1: Consultant Project Rates -->
    <mat-tab label="Consultant Project Rates" [disabled]="isOtherTabsDisabled" class="h-full w-full">
      <app-consultant-rates-tab></app-consultant-rates-tab>
    </mat-tab>

    <!-- Tab 2: Project Tasks -->
    <mat-tab label="Project Tasks" [disabled]="isOtherTabsDisabled" class="h-full w-full">
      <app-project-tasks-tab></app-project-tasks-tab>
    </mat-tab>

    <!-- Tab 3: Invoice/Prepayment Details -->
    <mat-tab label="Invoice/Prepayment Details" [disabled]="isOtherTabsDisabled" class="h-full w-full">
      <app-invoice-prepayment-tab></app-invoice-prepayment-tab>
    </mat-tab>
  </mat-tab-group>
</div>
